import { configSettings } from '@/lib';
import integrationIconGoogleCalendar from '@/assets/icons/integrations/google-calendar.svg';
import integrationIconZoom from '@/assets/icons/integrations/zoom.svg';
import integrationIconZapier from '@/assets/icons/integrations/zapier.svg';
import integrationIconInstagram from '@/assets/icons/integrations/instagram.svg';
import type { Integration } from '../types/integrations.types';

export const INTEGRATIONS: Integration[] = [
    {
        id: 'google-calendar',
        name: 'Google Calendar',
        title: 'Google Calendar',
        subtitle: 'Our Built-in Calendar Product',
        description:
            "Stop paying for boring calendar scheduling tools and instead use Stan's built-in calendar feature to keep everything under one roof.",
        icon: integrationIconGoogleCalendar,
        status: 'disconnected',
        documentationUrl: 'https://help.stan.store/article/51-how-to-sync-your-google-calendar-with-stan',
    },
    {
        id: 'zoom',
        name: 'Zoom',
        title: 'Zoom',
        subtitle: 'Meet with Customers on Zoom',
        description:
            'Integrate Zoom with your Stan account to simplify the scheduling process and automatically send Zoom meeting links to customers who book a time on your calendar.',
        icon: integrationIconZoom,
        status: 'disconnected',
        documentationUrl: 'https://help.stan.store/article/50-how-to-connect-stan-with-zoom',
    },
    {
        id: 'zapier',
        name: 'Zapier',
        title: 'Zapier',
        subtitle: 'Connect Stan With 3rd Party Tools',
        description:
            "Have a favorite tool that you'd like to connect to Stan? Use Zapier to remove the manual work and automate your processes.",
        icon: integrationIconZapier,
        status: 'disconnected',
        documentationUrl: configSettings.zapierInviteLink || 'https://zapier.com/apps/stan-creator/integrations',
    },
    {
        id: 'instagram',
        name: 'Instagram',
        title: 'Instagram',
        subtitle: 'Send Automated Replies',
        description: 'Connect your Instagram account to automatically reply to Instagram messages and comments!',
        icon: integrationIconInstagram,
        status: 'disconnected',
        documentationUrl: 'https://help.stan.store/article/377-ig-auto-reply',
    },
];
